import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=55ff5db7&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "./Policy.vue?vue&type=style&index=0&id=55ff5db7&prod&lang=scss&scoped=true"
import style1 from "./Policy.vue?vue&type=style&index=1&id=55ff5db7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff5db7",
  null
  
)

export default component.exports